import request from '@/utils/request'

export function getActivityPage(params) {
  return request({
    url: '/admin/activity/page',
    method: 'get',
    params
  })
}

export function getActivityList(params) {
  return request({
    url: '/admin/activity/list',
    method: 'get',
    params
  })
}

export function getActivityDetail(id) {
  return request({
    url: `/admin/activity/${id}`,
    method: 'get'
  })
}

export function createActivity(data) {
  return request({
    url: '/admin/activity',
    method: 'post',
    data
  })
}

export function updateActivity(data) {
  return request({
    url: '/admin/activity',
    method: 'put',
    data
  })
}

export function deleteActivity(ids) {
  return request({
    url: '/admin/activity',
    method: 'delete',
    data: ids
  })
}

export function updateActivityStatus(id, status) {
  return request({
    url: `/admin/activity/${id}/status`,
    method: 'put',
    params: { status }
  })
}

export function setActivityTop(id, isTop) {
  return request({
    url: `/admin/activity/${id}/top`,
    method: 'put',
    params: { isTop }
  })
}

export function incrementViewCount(id) {
  return request({
    url: `/admin/activity/${id}/view`,
    method: 'put'
  })
}

export function getActivityStatistics(params) {
  return request({
    url: '/admin/activity/statistics',
    method: 'get',
    params
  })
}

export function uploadActivityImage(data, onUploadProgress) {
  return request({
    url: '/admin/activity/upload',
    method: 'post',
    data,
    headers: {
      'Content-Type': 'multipart/form-data'
    },
    timeout: 600000,
    onUploadProgress
  })
}
